import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import withNavigation from '../../utils/withNavigation';
import { Card, Button, Input, message, Select, Radio } from 'antd';
import { Animated } from "react-animated-css";

import 'moment-timezone';
import moment from 'moment';
import axios from 'axios';

import UserModal from './modal/UserModal';

import './usermanagement.css';
import './SettingsPage.css';

import { EditOutlined, SettingOutlined, LogoutOutlined, DownloadOutlined } from '@ant-design/icons';

import {
	userList,
	userDelete,
	userLogout
} from '../../modules/user';
import { getUserStationList } from '../../modules/analytics';

import { version } from '../../config';
import config from '../../config';
import tokenApi from '../../modules/api/tokenApi';

const LOG_START_MONTH = '2025-08';
const WEATHER_START_MONTH = '2025-11';
const WEATHER2_START_MONTH = '2025-11';

class SettingsPage extends Component {
	constructor(props){
		super(props);
    const defaultLogMonth = this.getDefaultMonthValue(LOG_START_MONTH);
    const defaultWeatherMonth = this.getDefaultMonthValue(WEATHER_START_MONTH);
    const defaultWeather2Month = this.getDefaultMonthValue(WEATHER2_START_MONTH);
		this.state = {
			addModal: false,
			selectedUser: null,
			downloadMonth: defaultLogMonth,
			downloadId: '10c782700118162c3b',
			downloading: false,
      weatherMonth: defaultWeatherMonth,
      weatherDataset: 'weather',
      weatherStationId: '',
      weatherDownloading: false,
      weather2Month: defaultWeather2Month,
      weather2Downloading: false
		}
	}

  getMonthOptions(startMonth) {
    const earliest = moment(startMonth, 'YYYY-MM').startOf('month');
    const current = moment().startOf('month');
    const cursor = current.isBefore(earliest) ? earliest.clone() : current.clone();
    const options = [];
    while (cursor.isSameOrAfter(earliest)) {
      const formatted = cursor.format('YYYY-MM');
      options.push({ value: formatted, label: formatted });
      cursor.subtract(1, 'month');
    }
    return options;
  }

  getDefaultMonthValue(startMonth) {
    const [firstOption] = this.getMonthOptions(startMonth);
    return firstOption ? firstOption.value : '';
  }

  getSortedStations(stations = []) {
    return [...stations].sort((a, b) => {
      const nameA = (a.stationName || a.stationId || '').toLowerCase();
      const nameB = (b.stationName || b.stationId || '').toLowerCase();
      if (nameA === nameB) {
        return (a.stationId || '').localeCompare(b.stationId || '');
      }
      return nameA.localeCompare(nameB);
    });
  }

  setDefaultWeatherStation(stations = []) {
    if (this.state.weatherStationId || !stations.length) {
      return;
    }
    const sortedStations = this.getSortedStations(stations);
    if (sortedStations.length > 0) {
      this.setState({ weatherStationId: sortedStations[0].stationId });
    }
  }

	componentDidMount() {
    this.props.getUserStationList().then((stations = []) => {
      this.setDefaultWeatherStation(stations);
    }).catch(() => {});
	}

	componentDidUpdate(prevProps) {
    if (prevProps.userStationList !== this.props.userStationList) {
      this.setDefaultWeatherStation(this.props.userStationList);
    }
	}

	toggleAddModal = () => {
		const { addModal } = this.state;
		this.setState({ addModal: !addModal });
	}

	onSelectUser(user = null) {
		this.setState({ selectedUser: user.email });
	}

  handleDownloadMonthChange = (value) => {
    this.setState({ downloadMonth: value });
  }

  handleDownloadIdChange = (event) => {
    this.setState({ downloadId: event.target.value });
  }

  handleDownloadLogs = async () => {
    const { downloadMonth, downloadId } = this.state;
    if (!downloadMonth) {
      message.warning('Please select a month.');
      return;
    }
    const trimmedId = (downloadId || '').trim();
    if (!trimmedId) {
      message.warning('Please enter an inverter ID.');
      return;
    }

    this.setState({ downloading: true });
    try {
      const monthParam = downloadMonth;
      const baseUrl = config.api.replace(/\/$/, '');
      const requestUrl = `${baseUrl}/download/logs?month=${encodeURIComponent(monthParam)}&id=${encodeURIComponent(trimmedId)}`;
      const token = await tokenApi.GetTokenAsync();
      const response = await axios.get(requestUrl, {
        responseType: 'blob',
        headers: { Authorization: token }
      });

      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      const fileName = `filtered_reports_${monthParam}_${trimmedId}.csv`;
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }

      message.success('Log report downloaded.');
    } catch (error) {
      const status = error?.response?.status;
      if (status === 404) {
        message.error('No logs found for the selected month and ID.');
      } else if (status === 400) {
        message.error('Invalid request. Please review the filters and try again.');
      } else {
        message.error('Unable to download logs at the moment. Please try again later.');
      }
    } finally {
      this.setState({ downloading: false });
    }
  }

  handleWeatherMonthChange = (value) => {
    this.setState({ weatherMonth: value });
  }

  handleWeatherDatasetChange = (event) => {
    this.setState({ weatherDataset: event.target.value });
  }

  handleWeatherStationChange = (value) => {
    this.setState({ weatherStationId: value });
  }

  handleWeather2MonthChange = (value) => {
    this.setState({ weather2Month: value });
  }

  handleDownloadWeatherData = async () => {
    const { weatherMonth, weatherStationId, weatherDataset } = this.state;
    if (!weatherMonth) {
      message.warning('Please select a month.');
      return;
    }
    if (!weatherStationId) {
      message.warning('Please select a station.');
      return;
    }

    this.setState({ weatherDownloading: true });
    try {
      const monthParam = weatherMonth;
      const baseUrl = config.api.replace(/\/$/, '');
      const requestUrl = `${baseUrl}/download/weather-data?month=${encodeURIComponent(monthParam)}&stationId=${encodeURIComponent(weatherStationId)}&dataset=${encodeURIComponent(weatherDataset)}`;
      const token = await tokenApi.GetTokenAsync();
      const response = await axios.get(requestUrl, {
        responseType: 'blob',
        headers: { Authorization: token }
      });

      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      const fileName = `${weatherDataset}_${weatherStationId}_${monthParam}.csv`;
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
      message.success('Weather data downloaded.');
    } catch (error) {
      const status = error?.response?.status;
      if (status === 404) {
        message.error('No weather data found for the selected filters.');
      } else if (status === 400) {
        message.error('Invalid request. Please review the filters and try again.');
      } else {
        message.error('Unable to download weather data right now.');
      }
    } finally {
      this.setState({ weatherDownloading: false });
    }
  }

  handleDownloadWeather2Data = async () => {
    const { weather2Month } = this.state;
    if (!weather2Month) {
      message.warning('Please select a month.');
      return;
    }

    this.setState({ weather2Downloading: true });
    try {
      const baseUrl = config.api.replace(/\/$/, '');
      const requestUrl = `${baseUrl}/download/weather2-data?month=${encodeURIComponent(weather2Month)}&format=csv`;
      const token = await tokenApi.GetTokenAsync();
      const response = await axios.get(requestUrl, {
        responseType: 'blob',
        headers: { Authorization: token }
      });

      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      const fileName = `weather2_${weather2Month}.csv`;
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }

      message.success('Weather2 data downloaded.');
    } catch (error) {
      const status = error?.response?.status;
      if (status === 404) {
        message.error('No weather2 data found for the selected month.');
      } else if (status === 400) {
        message.error('Invalid request. Please review the filters and try again.');
      } else {
        message.error('Unable to download weather2 data right now.');
      }
    } finally {
      this.setState({ weather2Downloading: false });
    }
  }

  editUser = () => {
    const { userProfile } = this.props;
		const { addModal } = this.state;
    this.setState({ selectedUser: userProfile.user.email, addModal: !addModal});
  }


  addUser = () => {
		const { addModal } = this.state;
    this.setState({ selectedUser: null, addModal: !addModal});
  }

	onDeleteConfirm(user) {
		const { selectedUser } = this.state;
		this.props.userDelete(user.id).then(
			(res) => {
				if (user.email === selectedUser) {
					this.setState({ selectedUser: null });
				}
			},
			(err) => {
				this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` });
			}
		);
	}

  onLogout = () => {
    this.props.userLogout();
    this.props.navigate('/login');
  }

	onGoTo(loc) {
		this.props.navigate(loc);
	}

		render() {
		const { addModal, selectedUser, downloadMonth, downloadId, downloading, weatherMonth, weatherDataset, weatherStationId, weatherDownloading, weather2Month, weather2Downloading } = this.state;
    const { userProfile, userStationList }  = this.props;

    const logMonthOptions = this.getMonthOptions(LOG_START_MONTH);
    const weatherMonthOptions = this.getMonthOptions(WEATHER_START_MONTH);
    const weather2MonthOptions = this.getMonthOptions(WEATHER2_START_MONTH);
    const sortedStations = this.getSortedStations(userStationList || []);

		const sUser = this.props.userData.find(user=>user.email === selectedUser) || userProfile.user;

		let label_style = {width:120, justifyContent:'right', fontWeight:'bold'};
		return (
			<Animated animationIn="fadeIn">
                                <div className="settingsWrapper">
          <Card className="settingsCard">
            <div className="cardHeader">
              <h3 className="title"><SettingOutlined /> System Settings</h3>
              <div className="actions">
                <Button type="link" className="linkAction" onClick={()=>{this.editUser()}}>
                  <EditOutlined /> Edit
                </Button>
                <Button className="outlineAction" onClick={this.onLogout}>
                  <LogoutOutlined /> Logout
                </Button>
              </div>
            </div>
            <div className="cardBody">
              <div className="infoGrid">
                <div className="infoItem">
                  <span className="label">Contact Name</span>
                  <span className="value">{userProfile.user.name}</span>
                </div>
                <div className="infoItem">
                  <span className="label">Email</span>
                  <span className="value">{userProfile.user.email}</span>
                </div>
                <div className="infoItem">
                  <span className="label">Role</span>
                  <span className="value">{userProfile.user.role}</span>
                </div>
                <div className="infoItem muted">
                  <span className="label">Version</span>
                  <span className="value">{`v${version}`}</span>
                </div>
              </div>
            </div>
          </Card>
          <Card className="settingsCard">
            <div className="cardHeader">
              <h3 className="title"><DownloadOutlined /> Log Download</h3>
            </div>
            <div className="cardBody">
              <div className="downloadRow">
                <Select
                  placeholder="Select month"
                  value={downloadMonth || undefined}
                  onChange={this.handleDownloadMonthChange}
                  options={logMonthOptions}
                  className="monthSelect"
                />
                <Input
                  placeholder="Inverter ID"
                  value={downloadId}
                  onChange={this.handleDownloadIdChange}
                />
                <Button
                  type="primary"
                  className="primaryAction"
                  icon={<DownloadOutlined />}
                  onClick={this.handleDownloadLogs}
                  loading={downloading}
                >
                  Download CSV
                </Button>
              </div>
            </div>
          </Card>
          <Card className="settingsCard">
            <div className="cardHeader">
              <h3 className="title"><DownloadOutlined /> Weather Data Download</h3>
              <Radio.Group
                className="datasetSwitch"
                optionType="button"
                buttonStyle="solid"
                value={weatherDataset}
                onChange={this.handleWeatherDatasetChange}
              >
                <Radio.Button value="weather">Weather</Radio.Button>
                <Radio.Button value="forecast">Forecast</Radio.Button>
              </Radio.Group>
            </div>
            <div className="cardBody">
              <div className="downloadRow weatherRow">
                <Select
                  placeholder="Select month"
                  value={weatherMonth || undefined}
                  onChange={this.handleWeatherMonthChange}
                  options={weatherMonthOptions}
                  className="monthSelect"
                />
                <Select
                  showSearch
                  placeholder="Select station"
                  value={weatherStationId || undefined}
                  onChange={this.handleWeatherStationChange}
                  optionFilterProp="label"
                  className="stationSelect"
                  options={sortedStations.map((station) => ({
                    value: station.stationId,
                    label: `${station.stationName || station.stationId} (${station.stationId})`,
                  }))}
                  filterOption={(input, option) =>
                    (option?.label || '').toLowerCase().includes(input.toLowerCase())
                  }
                />
                <Button
                  type="primary"
                  className="primaryAction"
                  icon={<DownloadOutlined />}
                  onClick={this.handleDownloadWeatherData}
                  loading={weatherDownloading}
                >
                  Download CSV
                </Button>
              </div>
            </div>
          </Card>
          <Card className="settingsCard">
            <div className="cardHeader">
              <h3 className="title"><DownloadOutlined /> Weather2 Data Download</h3>
            </div>
            <div className="cardBody">
              <div className="downloadRow">
                <Select
                  placeholder="Select month"
                  value={weather2Month || undefined}
                  onChange={this.handleWeather2MonthChange}
                  options={weather2MonthOptions}
                  className="monthSelect"
                />
                <Button
                  type="primary"
                  className="primaryAction"
                  icon={<DownloadOutlined />}
                  onClick={this.handleDownloadWeather2Data}
                  loading={weather2Downloading}
                >
                  Download CSV
                </Button>
              </div>
            </div>
          </Card>
          <UserModal
            show={addModal}
            toggleAddUserModal={this.toggleAddModal.bind(this)}
            data={(selectedUser)?sUser:null}
          />

				</div>
			</Animated>
		);
	}
}

const mapStateToProps = state => ({
	router: state.router,
	userData: state.user.userData,
	userProfile: state.user.userProfile,
  userStationList: state.analytics.userStationList || []
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		userList,
		userDelete,
		userLogout,
    getUserStationList
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(withNavigation(SettingsPage));
